import { render, staticRenderFns } from "./CreateService.vue?vue&type=template&id=398ac78b&scoped=true&"
import script from "./CreateService.vue?vue&type=script&lang=js&"
export * from "./CreateService.vue?vue&type=script&lang=js&"
import style0 from "./CreateService.vue?vue&type=style&index=0&id=398ac78b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398ac78b",
  null
  
)

export default component.exports